export default __webpack_public_path__ + "static/goway-travel-cappadocia-turkey-290ed2b27f118d8d31e0adec9fbb7f9f.jpg";